import { AXIOS_ERROR, HTTP_STATUS, SERVER_ERROR } from '~/constants';
import i18n from '~/i18n';
import cond from 'ramda/es/cond';
import equals from 'ramda/es/equals';
import mergeDeepRight from 'ramda/es/mergeDeepRight';

export const getXHRMessage = (status, params = {}) => {
  return cond<any, any>([
    [
      equals(HTTP_STATUS.UNKNOWN),
      () => i18n.t('UNKNOWN', mergeDeepRight({ defaultValue: '일시적인 오류입니다.' }, params)),
    ],
    [
      equals(HTTP_STATUS.UNAUTHORIZED),
      () =>
        i18n.t(
          'UNAUTHORIZED',
          mergeDeepRight({ defaultValue: '로그아웃 되었습니다.\n 다시 로그인 해주세요.' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.FORBIDDEN),
      () => i18n.t('FORBIDDEN', mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)),
    ],
    [
      equals(HTTP_STATUS.NOT_FOUND),
      () => i18n.t('NOT_FOUND', mergeDeepRight({ defaultValue: '요청한 내용을 찾을 수 없습니다.' }, params)),
    ],
    [
      equals(HTTP_STATUS.INTERNAL_SERVER_ERROR),
      () => i18n.t('INTERNAL_SERVER_ERROR', mergeDeepRight({ defaultValue: '일시적인 오류입니다.' }, params)),
    ],
    [
      equals(HTTP_STATUS.NOT_IMPLEMENTED),
      () =>
        i18n.t(
          'NOT_IMPLEMENTED',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{error.status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.BAD_GATEWAY),
      () =>
        i18n.t(
          'BAD_GATEWAY',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.SERVICE_UNAVAILABLE),
      () =>
        i18n.t(
          'SERVICE_UNAVAILABLE',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.GATEWAY_TIMEOUT),
      () =>
        i18n.t(
          'GATEWAY_TIMEOUT',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.HTTP_VERSION_NOT_SUPPORTED),
      () =>
        i18n.t(
          'HTTP_VERSION_NOT_SUPPORTED',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{error.status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.INSUFFICIENT_STORAGE),
      () =>
        i18n.t(
          'INSUFFICIENT_STORAGE',
          mergeDeepRight({ defaultValue: '일시적인 오류입니다. 다시 한번 시도해주세요.({{error.status}})' }, params)
        ),
    ],
    [
      equals(HTTP_STATUS.UNAUTHORIZED),
      () =>
        i18n.t(
          'UNAUTHORIZED',
          mergeDeepRight({ defaultValue: '로그인 세션이 만료되었습니다.\n다시 로그인해주세요.' }, params)
        ),
    ],
    [
      equals(AXIOS_ERROR.ECONNABORTED),
      () => `${i18n.t('TEMP_ERROR', mergeDeepRight({ defaultValue: '일시적인 오류입니다.' }))}(1)`,
    ],
    [
      equals(SERVER_ERROR.SERVICE_GENERAL_ERROR),
      () =>
        i18n.t(
          'SERVICE_GENERAL_ERROR',
          mergeDeepRight({ defaultValue: '요청에 실패하였습니다.\n잠시 후 다시 시도해 주시기 바랍니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_ERROR',
          mergeDeepRight({ defaultValue: '일요청에 실패하였습니다.\n잠시 후 다시 시도해 주시기 바랍니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_GENERAL_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_GENERAL_ERROR',
          mergeDeepRight({ defaultValue: '요청에 실패하였습니다.\n잠시 후 다시 시도해 주시기 바랍니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_NOT_FOUND_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_NOT_FOUND_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 요청입니다. 다시 확인해 주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_EMPTY_BODY_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_EMPTY_BODY_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 요청입니다. 다시 확인해 주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_NOT_EXIST_QUERY_PARAM_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_NOT_EXIST_QUERY_PARAM_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 요청입니다. 다시 확인해 주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_TIMEOUT_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_TIMEOUT_ERROR',
          mergeDeepRight({ defaultValue: '요청에 실패하였습니다.\n잠시 후 다시 시도해 주시기 바랍니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_INVALID_REQUEST_BODY_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_INVALID_REQUEST_BODY_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 요청입니다. 다시 확인해 주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_CANNOT_SUPPORT_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_CANNOT_SUPPORT_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 요청입니다. 다시 확인해 주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_INVALID_APP_KEY_ERROR),
      () =>
        i18n.t('SERVICE_API_INVALID_APP_KEY_ERROR', mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_UNAUTHORIZED_APP_KEY_ERROR),
      () =>
        i18n.t(
          'SERVICE_API_UNAUTHORIZED_APP_KEY_ERROR',
          mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVICE_API_UNAUTHORIZED_IP_ERROR),
      () =>
        i18n.t('SERVICE_API_UNAUTHORIZED_IP_ERROR', mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.MEMBER_GENERAL_ERROR),
      () => i18n.t('MEMBER_GENERAL_ERROR', mergeDeepRight({ defaultValue: '잘못된 멤버 정보입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.MEMBER_NOT_EXISTS_ERROR),
      () => i18n.t('MEMBER_NOT_EXISTS_ERROR', mergeDeepRight({ defaultValue: '존재하지 않는 멤버입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.MEMBER_ALREADY_EXISTS_ERROR),
      () =>
        i18n.t(
          'MEMBER_ALREADY_EXISTS_ERROR',
          mergeDeepRight({ defaultValue: '이미 조직에 속해있는 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.MEMBER_PREFERENCE_IS_NULL_ERROR),
      () =>
        i18n.t(
          'MEMBER_PREFERENCE_IS_NULL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.MEMBER_INSERT_FAIL_ERROR),
      () =>
        i18n.t(
          'MEMBER_INSERT_FAIL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.MEMBER_CHANNEL_FAVORITE_FOLDER_TITLE_ALREADY_EXISTS_ERROR),
      () =>
        i18n.t(
          'MEMBER_CHANNEL_FAVORITE_FOLDER_TITLE_ALREADY_EXISTS_ERROR',
          mergeDeepRight({ defaultValue: '이미 사용 중인 이름입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_GENERAL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_GENERAL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_ALREADY_EXISTS_ERROR),
      () =>
        i18n.t('CHANNEL_ALREADY_EXISTS_ERROR', mergeDeepRight({ defaultValue: '이미 생성된 채팅방입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_NOT_EXISTS_ERROR),
      () => i18n.t('CHANNEL_NOT_EXISTS_ERROR', mergeDeepRight({ defaultValue: '존재하지 않는 채팅방입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_ALREADY_JOINED_ERROR),
      () => i18n.t('CHANNEL_ALREADY_JOINED_ERROR', mergeDeepRight({ defaultValue: '이미 초대된 멤버입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_NOT_JOINED_MEMBER_ERROR),
      () =>
        i18n.t(
          'CHANNEL_NOT_JOINED_MEMBER_ERROR',
          mergeDeepRight({ defaultValue: '채팅방에 없는 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_DB_ERROR),
      () =>
        i18n.t(
          'CHANNEL_DB_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_HAS_JOINED_MEMBER_ERROR),
      () =>
        i18n.t(
          'CHANNEL_HAS_JOINED_MEMBER_ERROR',
          mergeDeepRight({ defaultValue: '채팅방에 멤버가 남아있어 삭제할 수 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_CANNOT_DELETE_BOT_CHANNEL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_CANNOT_DELETE_BOT_CHANNEL_ERROR',
          mergeDeepRight({ defaultValue: '삭제할 수 없는 채팅방입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_CREATE_INVALID_CAPACITY_ERROR),
      () =>
        i18n.t(
          'CHANNEL_CREATE_INVALID_CAPACITY_ERROR',
          mergeDeepRight({ defaultValue: '채팅방에 최대 {{max}}명까지 초대할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_CAPACITY_IS_FULL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_CAPACITY_IS_FULL_ERROR',
          mergeDeepRight({ defaultValue: '채팅방에 최대 {{max}}명까지 초대할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_ARCHIVE_FAIL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_ARCHIVE_FAIL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_DIRECT_CANNOT_CHANGE_TITLE_ERROR),
      () =>
        i18n.t(
          'CHANNEL_DIRECT_CANNOT_CHANGE_TITLE_ERROR',
          mergeDeepRight({ defaultValue: '1:1 채팅방 제목은 변경할 수 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_TITLE_ALREADY_USED_ERROR),
      () =>
        i18n.t(
          'CHANNEL_TITLE_ALREADY_USED_ERROR',
          mergeDeepRight({ defaultValue: '이미 사용 중인 제목입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_CREATE_DIRECT_INVALID_MEMBER_IDS_ERROR),
      () =>
        i18n.t(
          'CHANNEL_CREATE_DIRECT_INVALID_MEMBER_IDS_ERROR',
          mergeDeepRight({ defaultValue: '잘못된 멤버 정보입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_GENERAL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_GENERAL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_DB_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_DB_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_INVALID_CHANNEL_PERMISSION_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_INVALID_CHANNEL_PERMISSION_ERROR',
          mergeDeepRight({ defaultValue: '관리자 설정 권한이 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_INVALID_FLAG_ERROR),
      () => i18n.t('CHANNEL_INVALID_FLAG_ERROR', mergeDeepRight({ defaultValue: '실행할 수 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_ADMIN_CANNOT_LEAVE_ERROR),
      () =>
        i18n.t(
          'CHANNEL_ADMIN_CANNOT_LEAVE_ERROR',
          mergeDeepRight(
            {
              defaultValue:
                '유일한 관리자라 대화방 나가기를 할 수 없습니다. 대화방 나가기를 하려면, 다른 멤버를 관리자로 지정하거나, 대화방 설정에서 관리자 기능을 해제해주세요.',
            },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_ALREADY_GRANTED_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_ALREADY_GRANTED_ERROR',
          mergeDeepRight({ defaultValue: '이미 초대된 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_ALREADY_JOINED_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_ALREADY_JOINED_ERROR',
          mergeDeepRight({ defaultValue: '이미 초대된 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_NOT_GRANTED_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_NOT_GRANTED_ERROR',
          mergeDeepRight({ defaultValue: '초대받지 않은 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_READ_SEQ_BIGGER_THAN_CHANNEL_SEQ_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_READ_SEQ_BIGGER_THAN_CHANNEL_SEQ_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_NOT_EXISTS_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_NOT_EXISTS_ERROR',
          mergeDeepRight({ defaultValue: '채팅방에 없는 멤버입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_CANNOT_SET_PREFERENCE_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_CANNOT_SET_PREFERENCE_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류가 발생하였습니다. 다시 한번 시도해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_PREFERENCE_IS_NULL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_PREFERENCE_IS_NULL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_IS_NOT_DIRECT_MEMBER_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_IS_NOT_DIRECT_MEMBER_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류(2)가 발생하였습니다. 서비스 운영자에게 문의해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_IS_INVALID_ERROR),
      () => i18n.t('CHANNEL_MEMBER_IS_INVALID_ERROR', mergeDeepRight({ defaultValue: '권한이 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_MEMBER_BELONG_TO_OTHER_ORG_ERROR),
      () =>
        i18n.t(
          'CHANNEL_MEMBER_BELONG_TO_OTHER_ORG_ERROR',
          mergeDeepRight({ defaultValue: '권한이 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_GENERAL_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_GENERAL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_BAD_SEQUENCE_ERROR),
      () =>
        i18n.t('CHANNEL_LOG_BAD_SEQUENCE_ERROR', mergeDeepRight({ defaultValue: '이미 삭제된 메시지입니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_CANNOT_SEND_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_CANNOT_SEND_ERROR',
          mergeDeepRight({ defaultValue: '메시지 전송 실패 [재전송, 취소]' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_CRYPTO_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_CRYPTO_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류가 발생하였습니다. 새로 고침 후 다시 한번 시도해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_SEND_MESSAGE_TOO_LONG_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_SEND_MESSAGE_TOO_LONG_ERROR',
          mergeDeepRight({ defaultValue: '최대 12,000자까지 전송할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_ATTACHMENT_SIZE_IS_TOO_BIG_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_ATTACHMENT_SIZE_IS_TOO_BIG_ERROR',
          mergeDeepRight({ defaultValue: 'Attachements 사이즈는 8,192kb를 초과할 수 없습니다. ' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_ALREADY_EXIST),
      () =>
        i18n.t(
          'CHANNEL_LOG_ALREADY_EXIST',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_EXPIRED_DELETE_TIME_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_EXPIRED_DELETE_TIME_ERROR',
          mergeDeepRight({ defaultValue: '작성 후, 5분 이내에만 삭제할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_LOG_EXPIRED_MODIFY_TIME_ERROR),
      () =>
        i18n.t(
          'CHANNEL_LOG_EXPIRED_MODIFY_TIME_ERROR',
          mergeDeepRight({ defaultValue: '작성 후, 5분 이내에만 수정할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.INTEGRATION_APP_NOT_EXIST_ERROR),
      () =>
        i18n.t(
          'INTEGRATION_APP_NOT_EXIST_ERROR',
          mergeDeepRight({ defaultValue: '연동서비스가 존재하지 않습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.INTEGRATION_COMMAND_NOT_REGISTERED_IN_CHANNEL_ERROR),
      () =>
        i18n.t(
          'INTEGRATION_COMMAND_NOT_REGISTERED_IN_CHANNEL_ERROR',
          mergeDeepRight({ defaultValue: '유효하지 않은 커맨드입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.INTEGRATION_COMMAND_NUMBER_OVER_LIMIT_ERROR),
      () =>
        i18n.t(
          'INTEGRATION_COMMAND_NUMBER_OVER_LIMIT_ERROR',
          mergeDeepRight({ defaultValue: '최대 {limitCount}개까지 생성 가능합니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.INTEGRATION_APP_NUMBER_OVER_LIMIT_ERROR),
      () =>
        i18n.t(
          'INTEGRATION_APP_NUMBER_OVER_LIMIT_ERROR',
          mergeDeepRight({ defaultValue: '최대 {limitCount}개까지 생성 가능합니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_GENERAL_ERROR),
      () =>
        i18n.t(
          'SERVER_GENERAL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_DB_ERROR),
      () =>
        i18n.t(
          'SERVER_DB_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.AUTH_FORBIDDEN_ACL_SERVICE_ERROR),
      () =>
        i18n.t(
          'AUTH_FORBIDDEN_ACL_SERVICE_ERROR',
          mergeDeepRight(
            {
              defaultValue:
                '접근이 제한된 사용자로 서비스에 접속할 수 없습니다.\n차단 해제 및 서비스 사용 문의는 내부 Dooray 관리자에게 문의해주세요.',
            },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.AUTH_FORBIDDEN_ACL_IP_ERROR),
      () =>
        i18n.t(
          'AUTH_FORBIDDEN_ACL_IP_ERROR',
          mergeDeepRight(
            {
              defaultValue:
                '접근이 제한된 사용자로 서비스에 접속할 수 없습니다.\n차단 해제 및 서비스 사용 문의는 내부 Dooray 관리자에게 문의해주세요.',
            },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_TASK_TRACKER_ERROR),
      () =>
        i18n.t(
          'SERVER_TASK_TRACKER_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_TASK_TRACKER_UNAUTHORIZED_SESSION_ERROR),
      () =>
        i18n.t(
          'SERVER_TASK_TRACKER_UNAUTHORIZED_SESSION_ERROR',
          mergeDeepRight({ defaultValue: '로그인이 필요합니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_TASK_TRACKER_TIMEOUT_ERROR),
      () =>
        i18n.t(
          'SERVER_TASK_TRACKER_TIMEOUT_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_GENERAL_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_GENERAL_ERROR',
          mergeDeepRight(
            { defaultValue: '서버 오류가 발생하였습니다. 해당 오류는 서비스 운영자에게 자동으로 보고됩니다.' },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_UPLOAD_FAIL_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_UPLOAD_FAIL_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류가 발생하였습니다. 다시 한번 시도해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_THUMBNAIL_FAIL_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_THUMBNAIL_FAIL_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류가 발생하였습니다. 다시 한번 시도해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_THUMBNAIL_UPLOAD_FAIL_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_THUMBNAIL_UPLOAD_FAIL_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류가 발생하였습니다. 다시 한번 시도해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_FILE_IS_NULL_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_FILE_IS_NULL_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류(3)가 발생하였습니다. 서비스 운영자에게 문의해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_TRANSFER_INVALID_HEADER_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_TRANSFER_INVALID_HEADER_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류(4)가 발생하였습니다. 서비스 운영자에게 문의해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_SIZE_IS_TOO_BIG_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_SIZE_IS_TOO_BIG_ERROR',
          mergeDeepRight({ defaultValue: '파일의 크기가 {{size}} 이하인 파일만 전송 가능합니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_EXPIRED_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_EXPIRED_ERROR',
          mergeDeepRight({ defaultValue: '다운로드 기간이 만료되었습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_UPLOAD_FORBIDDEN_EXTENSIONS_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_UPLOAD_FORBIDDEN_EXTENSIONS_ERROR',
          mergeDeepRight({ defaultValue: '첨부할 수 없는 파일입니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_DOWNLOAD_FORBIDDEN_EXTENSIONS_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_DOWNLOAD_FORBIDDEN_EXTENSIONS_ERROR',
          mergeDeepRight({ defaultValue: '차단된 형식의 파일로 열거나 다운로드할 수 없습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_SHARD_IS_NOT_READY),
      () =>
        i18n.t(
          'SERVER_SHARD_IS_NOT_READY',
          mergeDeepRight({ defaultValue: '서버 오류(5)가 발생하였습니다. 서비스 운영자에게 문의해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_SAME_SESSION_KEY),
      () =>
        i18n.t(
          'SERVER_SAME_SESSION_KEY',
          mergeDeepRight({ defaultValue: '접속이 끊어졌습니다. 다시 연결해주세요. ' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.AUTH_GENERAL_ERROR),
      () =>
        i18n.t(
          'AUTH_GENERAL_ERROR',
          mergeDeepRight({ defaultValue: '접속이 끊어졌습니다. 다시 연결해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.AUTH_UNAUTHORIZED_ERROR),
      () => i18n.t('AUTH_UNAUTHORIZED_ERROR', mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.AUTH_FORBIDDEN_ERROR),
      () => i18n.t('AUTH_FORBIDDEN_ERROR', mergeDeepRight({ defaultValue: '접근 권한이 없습니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.WEBSOCKET_INVALID_REQUEST_ERROR),
      () =>
        i18n.t(
          'WEBSOCKET_INVALID_REQUEST_ERROR',
          mergeDeepRight({ defaultValue: '서버 오류(6)가 발생하였습니다. 서비스 운영자에게 문의해주세요.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.TRAFFIC_ERROR),
      () =>
        i18n.t(
          'TRAFFIC_ERROR',
          mergeDeepRight({ defaultValue: '일시적인 오류가 발생했습니다. 잠시만 기다려 주세요. ' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_DESCRIPTION_LENGTH_TOO_LONG_ERROR),
      () =>
        i18n.t('limitKeywordLength', mergeDeepRight({ defaultValue: '최대 {{max}}글자까지 입력 가능합니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.CHANNEL_TITLE_LENGTH_TOO_LONG_ERROR),
      () =>
        i18n.t('limitKeywordLength', mergeDeepRight({ defaultValue: '최대 {{max}}글자까지 입력 가능합니다.' }, params)),
    ],
    [
      equals(SERVER_ERROR.INTEGRATION_APP_NUMBER_OVER_TENANT_LIMIT_ERROR),
      () =>
        i18n.t(
          'INTEGRATION_APP_NUMBER_OVER_TENANT_LIMIT_ERROR',
          mergeDeepRight({ defaultValue: '슬래시 커맨드는 {{max}}개까지 추가할 수 있습니다.' }, params)
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_FILE_OVER_LIMIT_OF_TOTAL_SIZE_PER_TENANT_ERROR),
      () =>
        i18n.t(
          'SERVER_FILE_OVER_LIMIT_OF_TOTAL_SIZE_PER_TENANT_ERROR',
          mergeDeepRight(
            {
              defaultValue:
                '사용할 수 있는 첨부파일 용량을 초과했습니다.\n 조직이 사용할 수 있는 첨부파일의 합은 {{max}} 입니다.',
            },
            params
          )
        ),
    ],
    [
      equals(SERVER_ERROR.SERVER_SIDE_APP_UNAVAILABLE_ERROR),
      () => i18n.t('SERVER_SIDE_APP_UNAVAILABLE_ERROR', '관리자에 의해 사용이 중지된 앱 입니다.'),
    ],
    [
      equals(SERVER_ERROR.INVALID_AI_LICENSE_ERROR),
      () => i18n.t('INVALID_AI_LICENSE_ERROR', '해당 기능에 대한 이용 권한이 없습니다.'),
    ],
    [equals(SERVER_ERROR.SERVICE_ACL_ERROR), () => i18n.t('SERVICE_ACL_ERROR', '접근 권한이 없습니다.')],
  ])(status);
};
